module.exports = __webpack_public_path__ + "files/annulering.a2d7fba6.pdf";